import DashboardCard from '@components/DashboardCard'
import React from 'react'
import { StyledCol } from './style'
import { PromoteFMIContent } from '@components/Widgets/PromoteFMI'

const CardPromoteFMI: React.FunctionComponent<{
  promoteSingle?: boolean
}> = ({ promoteSingle }) => (
  <StyledCol xs={12} sm={6} md={6} lg={3}>
    <DashboardCard>
      <PromoteFMIContent isBookingTab isSingleBooking={promoteSingle} />
    </DashboardCard>
  </StyledCol>
)

export default CardPromoteFMI
